import { render } from "./ArtistsList.vue?vue&type=template&id=38b8b1a2&scoped=true"
import script from "./ArtistsList.vue?vue&type=script&lang=js"
export * from "./ArtistsList.vue?vue&type=script&lang=js"

import "./ArtistsList.vue?vue&type=style&index=0&id=38b8b1a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b8b1a2"]])

export default __exports__